export const blogs = {
  blogsFeedCreateInputPlaceholder: 'Napište příspěvek...',
  blogsFeedSearchInputPlaceholder: 'Hledat',
  blogsFeedPostOwnerCurtainEditTitle: 'Upravit příspěvek',
  blogsFeedPostOwnerCurtainDeleteTitle: 'Smazat příspěvek',
  blogsFeedEditedPostSavedAlertText: 'Příspěvek uložen!',
  blogsFeedEditedPostDeletedAlertText: 'Příspěvek smazán!',
  blogsFeedShareCurtainOptionTitle: 'Zkopírovat odkaz',
  blogsFeedPostLinkCopiedAlertText: 'Odkaz zkopírován!',
  blogsFeedOthersPostCurtainOptionCopyTitle: 'Zkopírovat odkaz',
  blogsFeedOthersPosLinkCopiedAlertText: 'Odkaz zkopírován!',
  blogsFeedOthersPostCurtainOptionFlagTitle: 'Nahlásit obsah',
  blogsFeedOtherPostOwnersCurtainDeleteTitle: 'Smazat příspěvek',
  blogsFeedPostDeletePopupTitle: 'Smazat',
  blogsFeedPostDeletePopupText: 'Smazat tento příspěvek?',
  blogsFeedPostDeletePopupCancelButtonTitle: 'Zrušit',
  blogsFeedPostDeletePopupConfirmButtonTitle: 'Potvrdit',
  blogsFeedPostDeeletedAlertText: 'Příspěvek smazán!',
  blogsPostDetailsHeaderTitle: 'Příspěvek',
  postFeedPostLikesText: 'Líbí se',
  postFeedPostCommentsText: 'Komentáře',
  postFeedPostNoLikesText: 'Zatím zde nejsou žádné lajky',
  postFeedPostLeaveFirstLikeText: 'Můžete být první, kdo dá lajk',
  blogsFeedPostDetailsNoCommentsText: 'Zatím zde nejsou žádné komentáře',
  blogsFeedPostDetailsFirstCommentText: 'Můžete být první, kdo něco napíše',
  blogsFeedPostDetailsShareOptionTitle: 'Zkopírovat odkaz',
  blogsFeedPostDetailsSharePostCopiedAlertText: 'Odkaz zkopírován!',
  blogsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Zkopírovat odkaz',
  blogsFeedPostDetailsCopiedAlertText: 'Odkaz zkopírován!',
  blogsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Nahlásit obsah',
  blogsPostDetailsFlagCurtainOptionSpamTitle: 'Nahlásit',
  blogsPostDetailsReportedCurtainText: 'Obsah nahlášen',
  blogsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Upravit komentář',
  blogsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Smazat komentář',
  blogsPostDetailsEditedCommentSavedAlertText: 'Komentář uložen!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Smazat komentář',
  postDetailsOtherUsersCommentDeletadAlertText: 'Komentář smazán!',
  postDetailsDeleteCommentPopupTitle: 'Smazat',
  postDetailsDeleteCommentPopupText: 'Smazat tento komentář?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Zrušit',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Potvrdit',
  postDetailsCommDeletedAlertText: 'Komentář smazán!',
  postDetailsCommentUserCurtainOptionTitle: 'Nahlásit komentář',
  blogsCreatePostCurtainTitle: 'Nový příspěvek',
  blogsCreatePostCurtainBodyPlaceholder: 'Zde vložte svůj text...',
  blogsCreatePostPublishButtonTitle: 'Publikovat',
  blogsCreatePostUploadSlallerImageAlertText: 'Najednou můžete nahrát maximálně {size} MB',
  blogsPostSavedAlertText: 'Příspěvek uložen!',
  blogsCreatePostAddLocationCurtainTitle: 'Místo',
  blogsCreatePostAddLocationCurtainInputPlaceholder: 'Název místa',
  blogsCreatePostEditLocationCurtainText: 'Upravit místo',
  blogsDeleteLocation: 'Smazat místo',
  blogsDiscardPostPopupTitle: 'Návrh',
  blogsDiscardPostPopupText: 'Zrušit tento návrh?',
  blogsDiscardPostPopupCancelButtonTitle: 'Zrušit',
  blogsDiscardPostPopupCofirmButtonTitle: 'Potvrdit',
  blogsNewPostCreatePollTitle: 'Vytvořit průzkum',
  blogsNewPostCreatePollTitleInputPlaceholder: 'Název',
  blogsNewPostCreatePollOptionInputPlaceholder: 'Možnost',

  blogsNewPostCreatePollAddButtonTitle: 'Přidat možnost',
  blogsNewPostCreatePollCreateButtonTitle: 'Vytvořit',
  blogsCreatePostPollTitleBlankAlertText: 'Název nemůže být prázdný!',
  blogsCreatePostPollOptionBlankAlertText: 'Možnost nemůže být prázdná!',
  blogsCreatePostPollLongTitleAlertText: 'Název by měl obsahovat maximálně {length} znaků',
  blogsCreatePostPollLongOptionAlertText: 'Možnost by měla obsahovat maximálně {length} znaků',
  blogsCreatePostPollEditOptionTitle: 'Upravit průzkum',
  blogsCreatePostPollRemoveOptionTitle: 'Odstranit průzkum',
  blogsPostPollInfoVotesText: 'hlasů',
  blogsPostPollInfoEditVoteText: 'Upravit hlas',
  blogsPostPollFinishPollText: 'Ukončit průzkum',
  blogsPostPollFinishedPollText: 'Ukončeno',
  blogsPostPollInProgresslText: 'Probíhá',
  blogsFinishPollCurtainTitle: 'Ukončit průzkum',
  blogsFinishPollCurtainText: 'Po ukončení průzkumu už uživatelé nebudou moci hlasovat.',
  blogsFinishPollCurtainCancelButtonTitle: 'Zrušit',
  blogsFinishPollCurtainConfirmlButtonTitle: 'Potvrdit',
  blogsPollInfoPollVotesCurtainTitle: 'Hlasy v průzkumu',
  blogsEditPostCurtainTitle: 'Upravit příspěvek',
  blogsEditPostCurtainNoTextBodyPlaceholder: 'Zde vložte svůj text...',
  blogsEditPostCurtainSaveButtonTitle: 'Uložit',
  blogsEditPostSavedAlertText: 'Příspěvek uložen!',
  blogsError: 'Něco se pokazilo!',
  blogsAt: 'v',
  blogsSeeMore: 'Zobrazit více...',
  blogsMaxAttachments: 'Překročili jste maximální počet příloh. Maximální počet příloh je {length}',
  blogsReply: 'Odpovědět',
  blogsAddCover: 'Přidat obálku'
}
